// src/modules/gestionHumana/Horarios/utils/abacHorarios.js

export const TOPES_ORDINARIOS_DEFAULT = {
  CAJ: 42,
  SUR: 42,
  OPO: 42,
  ACP: 42,
  CAD: 42,
  OMT: 44,
  CFR: 48, // Coordinador Fruver: 48h ordinarias
  CRE: 54, // Coordinador Recibo: 54h ordinarias
  ADM: 54, // Administrador: 54h ordinarias
  SUB: 54, // Subadministrador: 54h ordinarias
  CON: 48
};

export const EXTRAS_MAX_POR_CARGO_DEFAULT = {
  CAJ: 6,
  SUR: 6,
  OPO: 6,
  ACP: 6,
  CAD: 4,
  OMT: 6,
  CFR: 6,
  CRE: 6,
  ADM: 6,
  SUB: 6,
  CON: 8
};

export const obtenerConfiguracionGlobalHoras = () => {
  try {
    const raw = localStorage.getItem('egs_config_horarios_v2');
    if (raw) {
      const parsed = JSON.parse(raw);
      return {
        porCargo: { ...TOPES_ORDINARIOS_DEFAULT, ...(parsed.porCargo || {}) },
        extrasMaxPorCargo: { ...EXTRAS_MAX_POR_CARGO_DEFAULT, ...(parsed.extrasMaxPorCargo || {}) },
        excepcionesSedeCargo: parsed.excepcionesSedeCargo || {},
        sedesExtrasHabilitadas: parsed.sedesExtrasHabilitadas || { TODAS: true }
      };
    }
  } catch (e) {}

  return {
    porCargo: { ...TOPES_ORDINARIOS_DEFAULT },
    extrasMaxPorCargo: { ...EXTRAS_MAX_POR_CARGO_DEFAULT },
    excepcionesSedeCargo: {},
    sedesExtrasHabilitadas: { TODAS: true }
  };
};

export const guardarConfiguracionGlobalHoras = (config) => {
  localStorage.setItem('egs_config_horarios_v2', JSON.stringify(config));
};

// Gestión de Solicitudes de Horas Extras (Flujo Punto -> Gerencia)
export const obtenerSolicitudesHorasExtras = () => {
  try {
    const raw = localStorage.getItem('egs_solicitudes_horas_extras');
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
};

export const guardarSolicitudHoraExtra = (nuevaSolicitud) => {
  const actuales = obtenerSolicitudesHorasExtras();
  const item = {
    id: Date.now(),
    estado: 'PENDIENTE', // 'PENDIENTE' | 'APROBADA' | 'RECHAZADA'
    fecha_solicitud: new Date().toISOString(),
    ...nuevaSolicitud
  };
  const actualizadas = [item, ...actuales];
  localStorage.setItem('egs_solicitudes_horas_extras', JSON.stringify(actualizadas));
  return item;
};

export const actualizarEstadoHoraExtra = (idSolicitud, nuevoEstado, aprobadoPor = 'Gerencia') => {
  const actuales = obtenerSolicitudesHorasExtras();
  const actualizadas = actuales.map(s =>
    s.id === idSolicitud
      ? { ...s, estado: nuevoEstado, aprobado_por: aprobadoPor, fecha_respuesta: new Date().toISOString() }
      : s
  );
  localStorage.setItem('egs_solicitudes_horas_extras', JSON.stringify(actualizadas));
  return actualizadas;
};

// Analiza el usuario y su ABAC para saber si ve todas las sedes o solo su sede asignada
export const resolverAlcanceABAC = (usuario, sedesDisponibles = []) => {
  let permisosABAC = {};
  try {
    const parsed = typeof usuario?.permisos_avanzados === 'string'
      ? JSON.parse(usuario.permisos_avanzados)
      : (usuario?.permisos_avanzados || {});
    permisosABAC = parsed.micros || parsed || {};
  } catch (e) {}

  const cargoUpper = String(usuario?.cargo || usuario?.rol || '').toUpperCase().trim();
  const esGerenciaOSuperAdmin =
    cargoUpper.includes('SUPER_ADMIN') ||
    cargoUpper.includes('GERENTE') ||
    cargoUpper.includes('GERENCIA') ||
    cargoUpper.includes('DIRECTOR') ||
    cargoUpper.includes('TALENTO HUMANO') ||
    cargoUpper.includes('SISTEMAS') ||
    Boolean(permisosABAC['Mostrar Todas las Sedes']) ||
    permisosABAC['Horarios']?.alcance === 'GLOBAL' ||
    permisosABAC['Gestión de Horarios']?.alcance === 'GLOBAL';

  if (esGerenciaOSuperAdmin) {
    return {
      esGlobal: true,
      esGerencia: true,
      sedesPermitidas: sedesDisponibles,
      sedeDefaultPrefijo: sedesDisponibles[0]?.prefijo || 'BAL',
      sedeDefaultId: sedesDisponibles[0]?.id ? String(sedesDisponibles[0].id) : ''
    };
  }

  // Si es Administrador de Punto u otro rol atado a una sede
  const idsPermitidosABAC = (
    permisosABAC['Horarios']?.sedes_ids ||
    permisosABAC['Gestión de Horarios']?.sedes_ids ||
    []
  ).map(String);

  const sedeUsuarioTexto = String(usuario?.sede_nombre || usuario?.centroTrabajo || usuario?.area_nombre || '').toUpperCase().trim();
  const idSedeUsuario = usuario?.sede_id ? String(usuario.sede_id) : '';

  const filtradas = sedesDisponibles.filter(s => {
    if (idsPermitidosABAC.includes(String(s.id)) || idsPermitidosABAC.includes(String(s.prefijo))) return true;
    if (idSedeUsuario && String(s.id) === idSedeUsuario) return true;
    if (sedeUsuarioTexto && (String(s.nombre).toUpperCase().includes(sedeUsuarioTexto) || sedeUsuarioTexto.includes(String(s.nombre).toUpperCase()))) {
      return true;
    }
    return false;
  });

  const listaFinal = filtradas.length > 0 ? filtradas : sedesDisponibles;

  return {
    esGlobal: filtradas.length === 0,
    esGerencia: false,
    sedesPermitidas: listaFinal,
    sedeDefaultPrefijo: listaFinal[0]?.prefijo || 'BAL',
    sedeDefaultId: listaFinal[0]?.id ? String(listaFinal[0].id) : ''
  };
};